// extracted by mini-css-extract-plugin
export default {"loader":"search_loader__+ksh+","spinner":"search_spinner__Petie"};